export default __webpack_public_path__ + "static/media/calender.9690a6d4.svg";